import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import languageConfig from "../../config/languageConfig";

/**
 * Guards routes that require a logged-in (non-admin) user.
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated, loading } = useSelector((s) => s.auth || {});

  const pathSegs = location.pathname.split("/").filter(Boolean);
  const first = pathSegs[0];
  const urlCodes = languageConfig.getUrlCodes();
  const signinPath = urlCodes.includes(first) ? `/${first}/signin` : "/signin";

  if (loading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        Checking session…
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={signinPath}
        replace
        state={{
          from: `${location.pathname}${location.search}${location.hash}`,
        }}
      />
    );
  }

  return <Outlet />;
}
